/**
 * Video
 */
document.addEventListener('DOMContentLoaded', function() {
	const videoContainerButton = document.querySelector('.js-video-button');

	if (!videoContainerButton) {
		return;
	}

	videoContainerButton.addEventListener('click', function() {
		this.classList.toggle('active');
		const container = document.querySelector('[data-video-container]');

		if (container) {
			container.classList.toggle('hidden');
		}
	});
});

document.addEventListener('DOMContentLoaded', function() {
	const videos = document.querySelectorAll('.js-video');
	const vModal = document.getElementById('vModal');

	if (!vModal) {
		return;
	}

	videos.forEach(function(video) {
		video.addEventListener('click', function() {
			const href = this.dataset.href;
			const clone = vModal.innerHTML.replace('__VIDEO__', href);

			document.body.insertAdjacentHTML('beforeend', clone);

			const close = document.querySelectorAll('.v-close');

			close.forEach(function(closeBtn) {
				closeBtn.addEventListener('click', function() {
					const modal = closeBtn.closest('.v-modal');
					modal.remove();
				});
			})
		});
	});

	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape') {
			const modals = document.querySelectorAll('.v-modal');

			modals.forEach(function(modal) {
				modal.remove();
			});
		}
	});
});
